import React, { useEffect, useState } from 'react';
import styles from './AppointmentTable.module.css';
import { ReactSVG } from 'react-svg';
import { Icons, TerminalsIcon } from '@/assets';
import CloseButton from '@/ctComponents/closeButton';
import SubmitButton from '@/ctComponents/submitButton';
import { bookApointment, editApointment, SaveApiResMessage } from '@/actions';
import { useNotify } from 'react-admin';
import CustomSelectEx from '../CustomSelectEx';
import { enableAutoBookScroll } from '@/utils/autobook-scroll';

const LicensePlateModal = ({
  setShow,
  selectedData,
  cellData,
  containerId,
  setAppointmentSet,
  edit,
  setDisplay,
  containerName,
  licensePlate,
  ContainerOptions,
  Container,
  SSL,
  Size,
  selectedStatus,
  containerAppointmentId,
  setSelected,
  terminalId,
}) => {
  const notify = useNotify();
  const [license, setLicense] = useState(
    licensePlate === 'N/A' ? null : licensePlate
  );
  console.log('containerAppointmentId', containerAppointmentId);
  const [loading, setLoading] = useState('');
  const [containers, setContainers] = useState(ContainerOptions);
  const [container, setContainer] = useState(Container);
  const licenseData = cellData?.data?.find((item) => item?.id === selectedData);
  const handleBookAppointment = () => {
    setLoading(true);
    edit
      ? editApointment({
          containerId: containerId || container?.label,
          TerminalAppointmentAvailabilityId: selectedData,
          license_plate: license,
          selectedStatus: selectedStatus,
        })
          .then((res) => {
            console.log('EditbookAppointment', res);
            setAppointmentSet((prev) => ({
              ...prev,
              [res?.data?.appointment?.terminal_appointment_availability
                ?.terminal_id]: {
                id: res?.data?.appointment?.action_current
                  ?.new_appointment_availability_id,
                status: 'PENDING_EDIT',
                statusText: 'Rescheduling',
                date: res?.data?.appointment?.action_current
                  ?.new_appointment_availability?.date,
                dateTocheck:
                  res?.data?.appointment?.terminal_appointment_availability
                    ?.date_to_check,
                terminal:
                  res?.data?.appointment?.action_current
                    ?.new_appointment_availability?.terminal?.slug,
                terminalId:
                  res?.data?.appointment?.terminal_appointment_availability
                    ?.terminal_id,
                time: `${res?.data?.appointment?.action_current?.new_appointment_availability?.time_start} - ${res?.data?.appointment?.action_current?.new_appointment_availability?.time_end}`,
                type: 1,
                shift: Number(
                  res?.data?.appointment?.terminal_appointment_availability?.shift.replace(
                    /shift/,
                    ''
                  )
                ),
                selectId:
                  res?.data?.appointment?.action_current
                    ?.new_appointment_availability_id,
                license_plate:
                  res?.data?.appointment?.action_current?.license_plate ===
                  'N/A'
                    ? null
                    : res?.data?.appointment?.action_current?.license_plate,
                reserve_history:
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.reserve_history || [],
                terminal_name:
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.terminal_name,
                terminal_address:
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.terminal_address,
                terminal_website:
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.terminal_website,
                terminal_links:
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.terminal_links,
                total_appointments:
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.total_appointments,
              },
            }));

            // notify(res.message, 'success');
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res?.message,
              mode: 'success',
            });
            setDisplay(false);
            setShow(false);
            setLoading(false);
            enableAutoBookScroll();
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Appointment Rescheduling Failed',
              message: err,
              mode: 'error',
            });
            setShow(false);
            setLoading(false);
          })
      : bookApointment({
          containerId: containerId || container?.label,
          TerminalAppointmentAvailabilityId: selectedData,
          license_plate: license === 'N/A' ? null : license,
          selectedStatus: selectedStatus,
        })
          .then((res) => {
            // console.log('BookAppointment', res, selectedData);
            setAppointmentSet((prev) => ({
              ...prev,
              [res?.data?.appointment?.terminal_appointment_availability
                ?.terminal_id]: {
                id: res?.data?.appointment?.id,
                status: res?.data?.appointment?.status,
                statusText: res?.data?.appointment?.status_text,
                date: res?.data?.appointment?.terminal_appointment_availability
                  ?.date,
                dateTocheck:
                  res?.data?.appointment?.terminal_appointment_availability
                    ?.date_to_check,
                terminal:
                  res?.data?.appointment?.terminal_appointment_availability
                    ?.terminal?.slug,
                terminalId:
                  res?.data?.appointment?.terminal_appointment_availability
                    ?.terminal_id,
                time: `${res?.data?.appointment?.terminal_appointment_availability.time_start} - ${res?.data?.appointment?.terminal_appointment_availability.time_end}`,
                type: res?.data?.appointment?.terminal_appointment_availability
                  ?.status,
                shift: Number(
                  res?.data?.appointment?.terminal_appointment_availability?.shift.replace(
                    /shift/,
                    ''
                  )
                ),
                selectId:
                  res?.data?.appointment?.terminal_appointment_availability?.id,
                license_plate:
                  res?.data?.appointment?.license_plate === 'N/A'
                    ? null
                    : res?.data?.appointment?.license_plate,
                reserve_history:
                  (prev &&
                    prev[
                      res?.data?.appointment?.terminal_appointment_availability
                        ?.terminal_id
                    ]?.reserve_history) ||
                  [],
                terminal_name:
                  prev &&
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.terminal_name,
                terminal_address:
                  prev &&
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.terminal_address,
                terminal_website:
                  prev &&
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.terminal_website,
                terminal_links:
                  prev &&
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.terminal_links,
                total_appointments:
                  prev &&
                  prev[
                    res?.data?.appointment?.terminal_appointment_availability
                      ?.terminal_id
                  ]?.total_appointments,
              },
            }));

            // notify(res.message, 'success');
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res?.message,
              mode: 'success',
            });
            setDisplay(false);
            setShow(false);
            setLoading(false);
            setContainer(null);
            setSelected &&
              setSelected((prev) => ({
                ...prev,
                Container: {},
              }));
            enableAutoBookScroll();
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Appointment Booking Failed',
              message: err,
              mode: 'error',
            });
            setShow(false);
            setLoading(false);
          });
  };
  const onCreateOptionContainer = (item) => {
    setContainer({
      label: `${item}`,
      value: `${item}`,
    });
  };

  return (
    <div className={styles.LicensePlateModalContainer}>
      <div className={styles.content}>
        <div className={styles.logoSection}>
          <div>
            <a className={styles.terminalLink} target="_blank">
              <img
                alt={cellData?.terminalSlug}
                width={120}
                src={TerminalsIcon[cellData?.terminalSlug?.replace(/\s+/g, '')]}
              />
            </a>
          </div>
        </div>
        <div className={styles.verticalDashed} />
        <div className={styles.rowContainer}>
          <div className={styles.details}>
            <div className={styles.detailItem}>
              <ReactSVG src={Icons.calendarday} />
              Date:
              <span className={styles.boldText}>
                {licenseData?.date?.replace(
                  /(\d{4})-(\d{2})-(\d{2})/,
                  '$2/$3/$1'
                )}
              </span>
            </div>
            <div className={styles.detailItem}>
              <ReactSVG src={Icons.containerIcon} />
              {!ContainerOptions ? 'Container Number' : 'SSL'}
              <span className={styles.boldText}>
                {!ContainerOptions ? containerName : SSL}
              </span>
            </div>
          </div>
          <div className={styles.details}>
            <div className={styles.detailItem}>
              <ReactSVG src={Icons.clocktime} />
              Time:
              <span
                className={
                  styles.boldText
                }>{`${licenseData?.time_start} - ${licenseData?.time_end} `}</span>
            </div>
            <div className={styles.detailItem}>
              <ReactSVG
                src={
                  !ContainerOptions
                    ? licenseData?.type === 2
                      ? Icons.DualShift
                      : Icons.SingleShift
                    : Icons.containerIcon
                }
                className={styles.icon}
              />
              {!ContainerOptions ? 'Type' : 'Size'}
              <span className={styles.boldText}>
                {!ContainerOptions
                  ? licenseData?.type === 2
                    ? 'Dual'
                    : 'Single'
                  : Size}
              </span>
            </div>
          </div>
          {ContainerOptions && (
            <div className={styles.detailItem}>
              <ReactSVG
                src={
                  licenseData?.type === 2 ? Icons.DualShift : Icons.SingleShift
                }
                className={styles.icon}
              />
              Type:
              <span className={styles.boldText}>
                {licenseData?.type === 2 ? 'Dual' : 'Single'}
              </span>
            </div>
          )}
        </div>
      </div>
      <div
        className={` grid sm:flex grid-cols-2 gap-4 sm:gap-0 items-center flex-row justify-between`}>
        {ContainerOptions && (
          <div className="w-full sm:w-96">
            <CustomSelectEx
              title="Container Number"
              placeholder="Container"
              value={container}
              onChange={(item) => setContainer(item)}
              options={containers}
              AddOption={true}
              Err={'Incorrect Container number'}
              onCreateOption={(inputValue) => {
                // This won't add to the list, just logs if needed
                // console.log('Temp created:', inputValue);
              }}
              onCreateOptionContainer={onCreateOptionContainer}
              font={true}
              dropdown={true}
              width={'100%'}
            />
          </div>
        )}

        <div className={`${styles.LicenseContainer}`}>
          <span>License Plate</span>
          <input
            className={styles.LicenseInput}
            value={license}
            maxLength={7}
            onChange={(e) => setLicense(e.target.value)}
            placeholder="Enter your License Plate"
          />
        </div>
      </div>
      <div className={styles.buttonsContainer}>
        <CloseButton onClick={() => setShow(false)} text={'Close'} />
        <SubmitButton
          text={edit ? 'Reschedule Now' : 'Book Now'}
          onClick={handleBookAppointment}
          loading={loading}
          disable={ContainerOptions && container?.label?.length !== 11}
        />
      </div>
    </div>
  );
};

export default LicensePlateModal;
